import React from 'react'
import Desc from '../LinkedDescription'

export default {
    backgroundImage: {
        description: <Desc utility="background">background-image</Desc>,
        sortWeight: -70
    },
    backgroundSize: {
        description: <Desc utility="background">background-size</Desc>,
        sortWeight: -70
    },
    backgroundPosition: {
        description: <Desc utility="background">background-position</Desc>,
        sortWeight: -70
    },
    backgroundRepeat: {
        description: <Desc utility="background">background-repeat</Desc>,
        sortWeight: -70
    }
}